module.exports = __webpack_public_path__ + "static/bookkeeping-logo-639ee024957f7b4f25fadb32b2eaba60.svg";